import React from 'react';
import { Button, Form } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';


export default class Filters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            index: '',
            documentType: '',
        };
        this.onFilterData = this.onFilterData.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    onFilterData() {
        if (!this.state.documentType && !this.state.firstName && !this.state.lastName && !this.state.index) {
            toast('Morate unijeti po čemu želite filtrirati podatke!');
        } else {
            this.props.onFilterData(
                this.state.documentType,
                this.state.firstName,
                this.state.lastName,
                this.state.index
            );
        }
    }


    render() {
        return (
            <div>
                <br />
                <br />
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Tip dokumenta</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite tip dokumenta"
                                value={this.state.documentType}
                                onChange={this.handleInputChange}
                                name="documentType"
                                options={this.props.documentTypes.filter(el => el.text === 'Statusna potvrda' || el.text === 'Prepis ocjena')}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>


                        <Form.Field>
                            <label>Broj indexa</label>
                            <input
                                value={this.state.index}
                                onChange={(e) => this.setState({ index: e.target.value })}
                                name="index"
                                placeholder="Unesite index"
                            />
                        </Form.Field>

                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>Ime</label>
                            <input
                                value={this.state.firstName}
                                onChange={(e) => this.setState({ firstName: e.target.value })}
                                name="firstName"
                                placeholder="Unesite ime"
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Prezime</label>
                            <input
                                value={this.state.lastName}
                                onChange={(e) => this.setState({ lastName: e.target.value })}
                                name="lastName"
                                placeholder="Unesite prezime"
                            />
                        </Form.Field>

                    </Form.Group>
                    <Button floated="right" basic="true" color="blue" onClick={this.props.filtersOff}>Odustani
                    </Button>
                    <Button floated="right" color="blue" onClick={this.onFilterData}>Filtriraj
                    </Button>

                </Form>
                <br/>
                <br/>
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/DocumentRequests/Filters.js